import { Link } from "react-router-dom";
import {
  ArrowRight,
  Bot,
  BookOpen,
  CalendarDays,
  Gamepad2,
  Gift,
  LayoutDashboard,
  TrendingUp,
  UserRoundPlus,
  Users,
} from "lucide-react";

const ICONS = {
  assistant: Bot,
  calendar: CalendarDays,
  dashboard: LayoutDashboard,
  games: Gamepad2,
  material: BookOpen,
  progress: TrendingUp,
  rewards: Gift,
  students: Users,
  tutors: UserRoundPlus,
};

const TONES = [
  "border-violet-200 bg-violet-50 text-violet-700",
  "border-cyan-200 bg-cyan-50 text-cyan-700",
  "border-amber-200 bg-amber-50 text-amber-700",
];

export function ContextualNav({ eyebrow = "Continúa desde aquí", title, description, items, testId = "contextual-nav" }) {
  return (
    <section className="play-card bg-white p-5 sm:p-6" data-testid={testId}>
      <p className="text-xs font-extrabold uppercase tracking-[.16em] text-violet-600">{eyebrow}</p>
      <h2 className="mt-1 font-display text-2xl font-extrabold text-slate-900">{title}</h2>
      {description && <p className="mt-1 max-w-2xl text-sm text-slate-500">{description}</p>}
      <div className={`mt-4 grid gap-3 ${items.length > 1 ? "sm:grid-cols-2" : ""} ${items.length > 2 ? "lg:grid-cols-3" : ""}`}>
        {items.map((item, index) => {
          const Icon = ICONS[item.icon] || ArrowRight;
          return (
            <Link key={item.to} to={item.to} className={`group flex min-h-[112px] items-center gap-4 rounded-2xl border-2 p-4 transition hover:-translate-y-0.5 hover:shadow-md ${TONES[index % TONES.length]}`}>
              <span className="play-icon h-12 w-12 shrink-0 bg-white text-current"><Icon className="h-7 w-7" /></span>
              <span className="min-w-0 flex-1">
                <span className="block font-display text-lg font-extrabold text-slate-900">{item.label}</span>
                <span className="mt-0.5 block text-xs font-semibold text-slate-600">{item.description}</span>
              </span>
              <ArrowRight className="h-5 w-5 shrink-0 transition-transform group-hover:translate-x-1" />
            </Link>
          );
        })}
      </div>
    </section>
  );
}
